import { render } from "./AddPurchase.vue?vue&type=template&id=8fb01b1c&scoped=true"
import script from "./AddPurchase.vue?vue&type=script&lang=js"
export * from "./AddPurchase.vue?vue&type=script&lang=js"

import "./AddPurchase.vue?vue&type=style&index=0&id=8fb01b1c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\estimate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb01b1c"]])

export default __exports__